import * as React from 'react'
import { styles } from './styles.css'

export const AboutSubscription: React.FC = () => {
  return (
    <section className={styles.card}>
      <h3 className={styles.heading}>今回お申し込みのプランについて</h3>
      <p className={styles.description}>
        こちらは季節のおまかせブーケが届く定期便です💐初回お届け完了後、2回目以降のスキップ・解約が可能になります（※次回発送の3日前正午までにお手続きください）。
      </p>
    </section>
  )
}
